export default {
	loading: '加载中...',
	web: {
		index: {
			login: "登录",
			sigupForFree: "免费注册"
		},
		signin: {
			email: "请输入邮箱",
			password: "请输入密码"
		},
		signup: {
			email: "请输入邮箱",
			password: "请输入密码（8-20位）",
			repassword: "确认输入密码"
		},
		rules: {
			emailCount: "长度不少于5位数",
			passwordCount: "长度在8到20位数",
		},
		forgetpassword: {
			email: "您的邮箱",
			code: "验证码"
		}
	},
	common: {
		close: "关闭",
		save: "保存",
		bye: "再见",
		cancel: "取消",
		sure: "确定",
		back: "返回",
		refresh: "刷新",
		update: "更新",
		later: "以后再说",
		add: "添加",
		clear: "清空",
		inDevelopment: "正在开发",
		items: "项",
		retry: "全部重试",
		unopened: "暂未开放",
		traffic: "配额"
	},
	home: {
		myDrives: "云列表",
		transfer: "跨云传输",
		sync: "跨云同步",
		myTasks: "任务列表",
		gift: "订阅",
		resource: "友情链接"
	},
	cloud: {
		new: "云存储",
		emptuyCloudList: "云盘列表空空如也",
		emptuyList: "空空如也",
		newFolder: "新建文件夹",
		emptyFolder: "这个文件夹是空的.",
		invalidTip:"已失效，请更新授权",
		oauthInvalid:"该云盘已过期，请更新授权信息",
		refresh: "刷新容量",
		update: "修改名称",
		delete: "移除云盘",
		reloadAuth: "更新授权",
		deletingCloud: "移除云盘",
		deleteTip: "如果该云盘有任务正在进行中, 移除云盘将会停止并删除与该云盘相关的所有任务, 确定要继续移除吗？",
		addSuccessTip: "云盘授权成功",
		addExistTip: "云盘授权已刷新",
		addFailTip: "云盘授权失败，或联系客服",
		addSuccess: "云盘添加成功, 请回到界面并刷新云盘列表",
		addExplain: "您可以在以下以开放的云盘列表中点击进行授权登录，点击后将弹出的第三方授权登录页面或跳转到第三方官网授权。",
		endExplain: "未来我们将会支持更多的云盘类型，如有您有希望尽快增加的云盘，请通过留言板告诉我们~感谢支持",
		baidu: "百度网盘",
		chinamobile: "中国移动云盘",
		drive123: "123云盘",
		webdav: "WebDav",
		tencent: "腾讯微云",
		ftp: "FTP",
		jianguoyun: "坚果云",
		drive115: "115网盘",
		thunder: "迅雷云盘",
		wps: "WPS文档",
		ai360:"360AI云盘",
		quark: "夸克网盘",
		guangya:"光鸭云盘",
		aliyun: "阿里云盘",
		onedrive: "微软云盘",
		googleDrive: "谷歌云盘",
		dropbox: "Dropbox",
		future: "在未来，我们将开发和支持更多的第三方云盘产品，如果你有想要添加的云盘类型，你可以通过电子邮件告诉我们，后续开放：",
		explorer: {
			myFiles: "根目录",
			name: "名称",
			size: "大小",
			updateTime: "更新时间",
			open: "打开",
			refresh: "刷新",
			delete: "删除",
			preview: "预览",
			rename: "重命名",
			mkdir: "新建文件夹",
			download: "下载",
			copyTo: "传输到",
			moveTo: "移动到",
			site: "跳转官网",

		},
		file: {
			pic: "图片",
			vedio: "视频",
			audio: "音频",
			book: "书籍"
		}
	},
	task: {
		new: "任务",
		title: "任务列表",
		newTask: "新建任务",
		deleteEmpty: "清空列表",
		empty: "任务列表是空的",
		restart: "重启",
		continue: "继续",
		resume: "恢复",
		delete: "删除",
		completed: "文件及文件夹成功率",
		status: {
			running: "运行中",
			waiting: "等待",
			success: "成功",
			failure: "失败",
			lessSuccess: "部分成功",
			mostSuccess: "大部分成功",
			cancel: "取消",
			pause:"暂停",
			recover:"继续",
			unkown: "未知"
		},
		delTitle: "删除任务",
		delTip: "是否要删除该任务？如果任务正在进行，删除后将会停止。",
		itemsSelected: "项被选中",
		sourceNotSelect: "未选择传输源",
		destinationNotSelect: "未选择传输目的地",
		createTip: "云端传输，无需在线，随时随地可登录查看.",
		syncCreateTip: "云端同步，当前默认同步间隔为1天"
	},
	transfer: {
		desc:"该功能支持将A云存储的文件/目录直接传输到B云存储的目录中，整个过程在云端离线运行。",
		addNewCloud: "添加云存储",
		source: "选择来源",
		baiduPath: "/apps/QianClouds",
		baiduOldPath:"/apps/小迈千云",
		baiduRoot: "只能选择\" /我的应用数据/QianClouds \"文件夹及子项",
		thunderLimit: "迅雷暂不支持作为来源",
		destination: "选择目标",
		setting: "设置",
		chipLable: "后缀名如: mp4",
		filterTip: "文件类型过滤器允许你设置自己的过滤规则,包含或者排除设置的选项,系统将根据文件名称的后缀来确定,您可以输入文件类型,如zip、jpg:",
		include: "包含下列文件",
		exclude: "排除下列文件",
		conflictTile: "文件冲突策略",
		taskName: "任务名称",
		cloudTips: "来源和目标单击名称可以进入云盘或文件夹",
		sendEmail: "任务完成后将结果发送到邮件",
		createNow: "开始传输",
		createSync: "开始同步",
		inLine: "该任务正在排队",
		calculating: "正在计算",
		timeRemaining: "估算时间",
		rateTip: "非SVIP下载通常会受官方权益限制，在传输小文件时，由于文件较小，速度看起来也会较慢哦",
		shortSpeed:"",
		folder: "文件夹",
		file: "文件",
		size: "大小",
		skipped: "已跳过",
		failed: "已失败",
		stopTitle: "停止任务",
		stopTip: "是否要停止当前正在运行的任务？",
		stop: "停止",
		cancel: "取消",
		loading: "加载中...",
		from: "来源",
		to: "目标",
		total: "共",
		items: "项",
		stoppingTask: "正在停止任务",
		taskSetting: "任务设置",
		fileConfict: "文件冲突策略",
		confictTip: "在云盘数据传输过程中,若发生文件冲突,将采取您在下列中所选中的策略来处理。",
		notificationEmail: "通知邮件",
		notificationPhoneTip: "请填写您的手机号码",
		notificationEmailTip: "请填写您的邮箱地址",
		time: "时间",
		avgRate: "平均速度",
		startTime: "开始时间",
		endTime: "结束时间",
		failDetails: "错误详情",
		FailDetails: "错误列表",
		path: "路径",
		cause: "原因",
	},
	sync: {
		desc:"该功能支持将A云存储的目录与B云存储的目录建立同步关系，定期同步，整个过程在云端离线运行。",
		resumeTitle: "恢复同步",
		resumeTip: "是否立即恢复同步"
	},
	user: {
		vipTipTitle: "技术服务反馈",
		vipNow: "点击反馈",
		vipGroup: "技术反馈",
		vipDesc: "您可以扫描下方微信二维码，可以反馈遇到的问题或系统故障，我们将最快为您响应。",
		messageWant: "在这里留言",
		messageBoardBut: "留言板",
		changeAvatar: "更换头像",
		avatarPreview: "预览",
		avatarUpload: "上传头像",
		avatarUploadClick: "点击上传",
		orderList: "订单记录",
		changePassword: "修改密码",
		resetPassword: "修改密码",
		newPassword: "输入你的新密码",
		reNewPassword: "重复你的新密码",
		checkPassword: "两次密码不一致",
		newPasswordCheck: "密码长度限制在8-20位",
		oldPassword: "输入你的旧密码",
		oldPasswordCheck: "密码长度限制在8-20位",
		passwordLimit: "至少8位长度",
		passwordSuccess: "密码修改成功",
		showPassword: "显示",
		logout: "退出",
		del: "注销账号",
		connectUs: "提交工单",
		start: "开始",
		feedback: "问题反馈",
		passwordCheck: "密码长度限制在8-20位",
		unlimited: "无限",
		sessionExpired: "登录会话已过期，请重新登录",
		feedbackDescribe: "亲爱的用户，非常感谢您使用我们的产品，如果在使用过程中出现问题，您可以反馈到以下邮箱，我们将在24小时内处理并回复您。在邮件中，您可以带来您的账号、问题详情、配合操作步骤或图片、视频等，这有利于帮您更快的定位问题，谢谢!"
	},
	gift: {
		type: {
			MONTHLY: "月度订阅"
		},
		compare: "对比权益",
		pricingTable: "服务套餐",
		subtitle: "您的多云数据资产安全管家 · 专业 · 安全 · 可信赖",
		orderDetails: "订单详情",
		describe: {
			dialogTitle: "QianClouds 服务协议与使用须知",
			intro: "请您在订阅前了解我们的服务机制。QianClouds 致力于提供合规、安全的云端数据备份与同步通道：",
			p1Title: "合规安全通道",
			p1Desc: "本产品基于官方API开发，不提供任何绕过官方限速的破解服务。您的实际传输速度和单文件大小上限，取决于您在对应云盘的官方会员权益以及QianClouds的通过权益。",
			p2Title: "按量消耗配额，透明计费",
			p2Desc: "数据传输（上传/下载/同步/备份等）按实际流量 1:1 消耗配额（如传输 1GB 文件，扣除 1GB 配额）。订阅周期为 1 年，配额包支持随时叠加购买。",
			p3Title: "受官方接口稳定性影响",
			p3Desc: "云存储服务受各平台政策及接口波动影响，偶尔可能出现连接延迟，我们会第一时间跟进适配。",
			expandHint: "查看各云盘详细传输限制对照表",
			detailTitle: "QianClouds 服务说明与计费规则",
			detailIntro: "感谢您选择 QianClouds。为了让您获得最佳的数据备份与同步体验，并保障您的账号安全，请仔细阅读以下服务说明：",
			d1Title: "一、 服务定位与安全机制",
			d1a: "QianClouds 是一款纯云端的多云存储数据资产安全服务平台，通过各云盘官方授权的 API 接口为您提供文件备份、同步与传输服务。",
			d1bTitle: "不破解、不存数据",
			d1b: "我们绝不提供任何绕过云存储官方限制或破解会员权益的服务。QianClouds 仅作为数据传输通道，不私自存储您的任何文件内容，保障您的隐私安全。",
			d1cTitle: "速度与权限规则",
			d1c: "QianClouds 提供传输通道和带宽配额，但具体的下载/上传速度以及单文件大小限制，需遵循您所在云盘的官方规则。若需提升传输速度或解除大文件限制，请前往对应云盘官方购买相关权益。",
			d2Title: "二、 计费与配额消耗规则",
			d2aTitle: "配额消耗逻辑",
			d2a: "在您使用产品的备份、同步、上传或下载等传输功能时，系统将按文件实际大小，1:1 消耗您的数据传输配额。（例如：成功传输一个 5GB 的视频，将扣除 5GB 配额）。",
			d2bTitle: "配额有效期",
			d2b: "所有订阅许可均按年计费。配额包支持重复购买且叠加使用，配额包自购买之日起有效期为 1 年，到期未使用完的配额将自动清零。",
			d2cTitle: "任务重试提示",
			d2c: "如因网络波动或接口异常导致任务失败并自动重试，自动重试不会消耗你的配额，仅当文件传输成功后扣减配额。但为了传输可靠性，建议您在进行大批量数据同步前，先使用少量文件测试通道连通性。",
			d3Title: "三、 各大云盘传输限制对照表",
			d3Note: "为避免因官方规则调整带来的误解，以下为目前各云盘在第三方工具（即本站）调用时的常见限制参考。具体限制以云盘官方最新政策为准。",
			tableNote: "若您遇到提示‘文件过大’或‘限速’，通常是由于云盘官方限制了非会员或第三方调用权限，建议检查您在该云盘的官方会员状态。",
			checkboxLabel: "我已阅读并了解上述服务说明，确认购买",
			orderBrief: "数据传输（备份/同步/上传/下载等）按实际流量 1:1 消耗配额。订阅按年计费，配额包可叠加购买，有效期 1 年。",
		},
		currentPlan: "当前计划",
		order: "立即订阅",
		vipDocument: "付费权益",
		freeDocument: "免费权益",

		tabs: {
			combo: "推荐套餐",
			retail: "基础套餐",
		},

		subscriptionTitle: "订阅许可",
		subscriptionDesc: "选择适合的订阅计划，享受每月续配额与全功能多云管理服务",
		trafficTitle: "数据传输配额包",
		trafficDesc: "灵活补充传输配额，与订阅许可叠加使用",
		trafficValid: "所有配额包有效期 1 年 · 配额可叠加",

		comboDesc: "",
		comboSave: "立省",

		/* ===== 订阅许可计划 (max 4 tiers) ===== */
		sub_free: {
			category: 'subscription',
			badge: '',
			color: "#617589",
			disabled: true,
			btnText: "当前免费版",
			title: {
				name: "体验版",
				price: "￥0",
				period: "/月",
				quota: "",
				id: "1",
				number: "2312Free",
			},
			features: {
				a: "支持部分云存储",
				j: "5GB/月免费配额",
				p: "支持云盘在线统一管理",
				i: "支持跨云传输功能",
				b: "单个文件传输",
				m: "最高1个文件并行传输",
				f: "最高3MB/s通过速度",
				c: "最多绑定 2 个云盘",
				k: "单文件最大 5GB"
			}
		},
		sub_month: {
			category: 'subscription',
			badge: "",
			color: "#3DB8C4",
			title: {
				name: "轻量入门版",
				price: "￥19.8",
				originalPrice: "￥38",
				period: "/月",
				quota: "",
				id: "80",
				number: "500GB-M-26072",
			},
			features: {
				a: "获得500GB传输配额",
				i: "支持全部云存储授权",
				
				p: "支持云盘在线统一管理",
				k: "支持跨云传输功能",
				l: "文件夹传输",
				c: "最高5个文件并行传输",
				b: "最高10MB/s通过速度",
				n: "最多绑定 10 个云盘",
				e: "单文件最大 60GB",
				d: "支持任务自动排队",
				f: "支持跨云同步功能",
				m: "提供工单技术支持",
			}
		},
		sub_pro: {
			category: 'subscription',
			badge: "最爱买",
			color: "#4aa377",
			title: {
				name: "个人标准版",
				price: "￥49.8",
				originalPrice: "49.8",
				period: "/月",
				quota: "",
				id: "81",
				number: "3000G-M-Y26072",
			},
			features: {
				a: "获得3TB传输配额",
				i: "支持全部云存储授权",
				
				p: "支持云盘在线统一管理",
				k: "支持跨云传输功能",
				l: "文件夹传输",
				c: "5个文件并行传输",
				b: "最高15MB/s通过速度",
				n: "最多绑定 10 个云盘",
				e: "单文件最大 60GB",
				d: "支持任务自动排队",
				f: "支持跨云同步功能",
				m: "提供工单技术支持",
			
			}
		},
		sub_ultra: {
			category: 'subscription',
			badge: "",
			color: "#4A90D9",
			title: {
				name: "进阶治理版",
				price: "￥79.8",
				originalPrice: "￥79.8",
				period: "/季",
				quota: "",
				id: "82",
				number: "6000G-M-Y26072",
			},
			features: {
				a: "一次性获得6TB传输配额",
				i: "支持全部云存储授权",
				
				p: "支持云盘在线统一管理",
				k: "支持跨云传输功能",
				l: "文件夹传输",
				c: "5个文件并行传输",
				b: "最高15MB/s通过速度",
				n: "最多绑定 10 个云盘",
				e: "单文件最大 60GB",
				d: "支持任务自动排队",
				f: "支持跨云同步功能",
				m: "提供工单技术支持",
			
				
			}
		},
		
		
		sub_unlimit_q: {
			category: 'subscription',
			badge: "最畅销",
			color: "#c49b3c",
			title: {
				name: "无限季度版",
				price: "￥168",
				originalPrice: "￥168",
				period: "/季",
				quota: "",
				id: "83",
				number: "Unlimit-Q-Y26072",
			},
			features: {
				a: "获得3个月无限配额使用",
				i: "支持全部云存储授权",
				p: "支持云盘在线统一管理",
				k: "支持跨云传输功能",
				l: "文件夹传输",
				c: "最高5个文件并行传输",
				b: "最高15MB/s通过速度",
				n: "最多绑定 10 个云盘",
				e: "单文件最大 60GB",
				d: "支持任务自动排队",
				f: "支持跨云同步功能",
				m: "提供工单技术支持",
				
			}
		},
		sub_unlimit_r: {
			category: 'subscription',
			badge: "",
			color: "#c49b3c",
			title: {
				name: "无限升级版",
				price: "￥198",
				originalPrice: "￥198",
				period: "/季 + 1个月",
				quota: "",
				id: "84",
				number: "Unlimit-R-Y26072",
			},
			features: {
				a: "获得4个月无限配额使用",
				i: "支持全部云存储授权",
				p: "支持云盘在线统一管理",
				k: "支持跨云传输功能",
				l: "文件夹传输",
				c: "最高5个文件并行传输",
				b: "最高15MB/s通过速度",
				n: "最多绑定 10 个云盘",
				e: "单文件最大 60GB",
				d: "支持任务自动排队",
				f: "支持跨云同步功能",
				m: "提供工单技术支持",
				
			}
		},
		
		// sub_day: {
		// 	category: 'subscription',
		// 	badge: "",
		// 	color: "#5DADE2",
		// 	title: {
		// 		name: "轻量即时版",
		// 		price: "￥8.8",
		// 		originalPrice: "￥19.8",
		// 		period: "/天",
		// 		quota: "",
		// 		id: "71",
		// 		number: "50GB-D-2607",
		// 	},
		// 	features: {
		// 		a: "一次性获得50GB传输配额",
		// 		p: "支持云盘在线统一管理",
		// 		k: "支持跨云传输功能",
		// 		c: "5个文件并行传输",
		// 		b: "最高10MB/s通过速度",
		// 		n: "最多绑定 10 个云盘",
		// 		e: "单文件最大 60GB",
		// 		d: "支持任务自动排队",
		// 	}
		// },
		/* ===== 数据传输配额包 (4-6 packs) ===== */
		// traffic_a: {
		// 	category: 'traffic',
		// 	badge: '',
		// 	color: "#7D9C58",
		// 	sale: true,
		// 	ext: 1,
		// 	title: {name:"2TB流量包", size: "2TB", price: "￥59", salePrice: "￥53.1", id: "63", number: "2TB-Y-2607" },
		// },
		// traffic_b: {
		// 	category: 'traffic',
		// 	badge: "最爱买",
		// 	color: "#4aa377",
		// 	sale: true,
		// 	ext: 3,
		// 	title: {name:"10TB流量包",size: "10TB", price: "￥199", salePrice: "￥179.1", id: "64", number: "10TB-Y-2607" },
		// },
		// traffic_c: {
		// 	category: 'traffic',
		// 	badge: '',
		// 	sale: true,
		// 	color: "#dc792a",
		// 	title: { name:"50TB流量包",size: "50TB", price: "￥899", salePrice: "￥809.1", id: "65", number: "50TB-Y-2607" },
		// },
		// traffic_d: {
		// 	category: 'traffic',
		// 	badge: "",
		// 	color: "#4aa377",
		// 	ext: 2,
		// 	title: {name:"5TB流量包",size: "5TB", price: "￥129", salePrice: "￥116.1", id: "68", number: "5TB-Y-2607" },
		// },

		// /* ===== 组合套餐 ===== */
		// combo_a: {
		// 	category: 'combo',
		// 	badge: "季度畅享",
		// 	color: "#5865A3",
		// 	title: {
		// 		name: "季度无限制畅享版",
		// 		subName: "个人标准版",
		// 		trafficSize: " 无限制",
		// 		price: "168",
		// 		originalPrice: "298",
		// 		save: "", 
		// 		id: "69",
		// 		number: "Unlimit-3M-P-2607",
		// 	},
		// 	features: {
		// 		a: "含个人标准版全部权益",
		// 		b: "无限配额有效期 3 个月",	
		// 	}
		// },
		// combo_b: {
		// 	category: 'combo',
		// 	badge: "季度畅享",
		// 	color: "#2D4090",
		// 	title: {
		// 		name: "季度无限制畅享版",
		// 		subName: "专业治理版",
		// 		trafficSize: " 无限制",
		// 		price: "298",
		// 		originalPrice: "498",
		// 		save: "", 
		// 		id: "70",
		// 		number: "Unlimit-3M-U-2607",
		// 	},
		// 	features: {
		// 		a: "含专业治理版全部权益",
		// 		b: "无限配额有效期 3 个月",
			
		// 	}
		// },
		// combo_c: {
		// 	category: 'combo',
		// 	badge: "推荐组合",
		// 	color: "#dc792a",
		// 	title: {
		// 		name: "黄金推荐版",
		// 		subName: "个人标准版订阅",
		// 		trafficSize: "5TB 数据配额包",
		// 		price: "￥149",
		// 		originalPrice: "188",
		// 		save: "￥39",
		// 		id: "66",
		// 		number: "C-Personal-5TB-Y-2607",
		// 	},
		// 	features: {
		// 		a: "含个人标准版全部订阅权益",
		// 		b: "共含 7TB 数据传输配额(自带2TB + 5TB配额包)",
		// 		c: "配额有效期 1 年",
				
		// 	}
		// },
		// combo_d: {
		// 	category: 'combo',
		// 	badge: "高阶全能", 
		// 	color: "#c49b3c", 
		// 	title: {
		// 		name: "铂金全能版",
		// 		subName: "专业治理版",
		// 		trafficSize: " 10TB 专属配额包",
		// 		price: "￥399",
		// 		originalPrice: "￥467",
		// 		save: "省￥68", 
		// 		id: "67",
		// 		number: "C-Ultra-10TB-Y-2607",
		// 	},
		// 	features: {
		// 		a: "含专业治理版全部权益",
		// 		b: "共含 14TB 高速传输配额 (自带4TB + 10TB配额包)",
			
		// 		d: "配额有效期 1 年",
			
		// 	}
		// },
		
		other: {
			a: "1. 套餐提供的速度为多文件常规并发数量下的最大支持速度，实际速度受到云盘官方会员权益、文件大小等影响。",
			b: "2. 无限套餐用户在总使用量超过设计阈值时，后续运行速度会有一定幅度降低。",
			c: "3. 套餐价格及权益可能随运营情况做出调整和变更，最终解释权归本站所有。"
		},
		multi: {
			desc: "* 单次订购量有效期为 1 年，多次购买可重复叠加配额。"
		},
	}
}